import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useBook = (id, options = {}) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get(`books/${id}`);

		return res.data?.data;
	};
	return useQuery(["books", id], () => fetch(), {
		...fetchConfig,
		...options,
	});
};

export default useBook;
